import { CreateAccountApiParameter } from "@NA/Handlers/ADIOnlineRegnFormSubmitHandler";
import isApiError from "@insite/client-framework/Common/isApiError";
import { ServiceResult, get, patch } from "@insite/client-framework/Services/ApiService";

interface GetStatesApiParameter {
    languageId: string;
    expand: string;
}

interface GetTranslationsApiParameter {
    languageId: string;
}

const statesUrl = "/api/v1/websites/current/countries";
const translationsUrl = "/api/v2/accounts/GetTransalationFr"
const addAccountUrl = "/api/v2/accounts"

export async function getStates(
    parameter: GetStatesApiParameter,
): Promise<any> {
    try {

        const resultModel = await get<any>(`${statesUrl}`, parameter as any);

        return {
            result: resultModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function getTranslations(
    parameter: GetTranslationsApiParameter,
): Promise<any> {
    try {
        
        const resultModel = await get<any>(`${translationsUrl}`, parameter as any);

        return {
            result: resultModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

interface AddAccountResultCustom {
    toEmail: string;
    uri: string;
    properties: { [key: string]: string };
    emailSent: boolean;
}

export async function addAccount(
    parameter: CreateAccountApiParameter,
): Promise<any> {
    try {
        
        const response: AddAccountResultCustom = await fetch('/api/v2/accounts', {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(parameter),
          }).then(response => response.json())
          .then(data => data)
          .catch(error => error);

        return response
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
